module.exports = __webpack_public_path__ + "1d50a1381b49dc773defb0a1bb071ccd.svg";